import React, {useState} from 'react';
import { initialPartnerFormData } from '../../utils/formData';

import {
    validatePartnerInfo,
  } from '../../utils/validation';


function PartnersForm() {
    const [currentStep, setCurrentStep] = useState(1);
        const [errors, setErrors] = useState({});
    
        // initialisation des  champs du formulaire
        const [formData, setFormData] = useState(initialPartnerFormData);
    
    
      // Fonction pour gérer les changements dans les champs
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
      // Fonction pour valider les champs
      const validateFields = () => {
        let newErrors = {};
            newErrors = validatePartnerInfo(formData);
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
    
        //fonction de soumission
        const handleSubmit = (e) => {
            e.preventDefault();
            if (validateFields()) {
              console.log('Formulaire soumis avec succès:', formData);
            }
          };

  return (
      <form onSubmit={handleSubmit} className='inscription-form'>
          <div className="form-step">
            <h2 className='inscription-title'>Ajouter un partenaire</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom</label>
                    <input type="text" placeholder="Entrez le nom du parténaire" name="name" value={formData.name} onChange={handleChange} />
                    {errors.name && <span className="error">{errors.name}</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="type-carte">Service:</label>
                    <select id="service-id" name="serviceId" value={formData.serviceId} onChange={handleChange}>
                        <option value="">Laboratoire</option>
                        <option value="bronze">generaliste</option>
                        <option value="argent">Prise de sang</option>
                    </select>
                    {errors.typeCarte && <span className="error">{errors.serviceId}</span>}
                </div>
                {/* <div className="form-group">
                    <label>Résidence</label>
                    <input type="text" name="residence" placeholder="Entrez la Résidence" value={formData.residence} onChange={handleChange}/>
                    {errors.residence && <span className="error">{errors.residence}</span>}
                </div> */}
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom d'utilisateur</label>
                    <input type="text" name="username" placeholder="Entrez le nom d'utilisateur" value={formData.username} onChange={handleChange} />
                    {errors.username && <span className="error">{errors.username}</span>}
                </div>
                <div className="form-group">
                    <label>Mot de passe</label>
                    <input type="password"  name="password" placeholder="Entrez le mot de passe" value={formData.password} onChange={handleChange} />
                    {errors.password && <span className="error">{errors.password}</span>}
                </div>
            </div>
            {/* <div className="form-row">
                <div className="form-group">
                <label>Genre</label>
                <select name="genre" value={formData.genre} onChange={handleChange}>
                    <option value="">Sélectionnez le Genre</option>
                    <option value="male">Masculin</option>
                    <option value="female">Féminin</option>
                </select>
                {errors.genre && <span className="error">{errors.genre}</span>}
                </div>
                <div className="form-group">
                    <label>Date de naissance</label>
                    <input type="date" name="dateNaissance" value={formData.dateNaissance} onChange={handleChange} />
                    {errors.dateNaissance && <span className="error">{errors.dateNaissance}</span>}
                </div>
            </div>  */}
          </div>
          <button type="submit" className="submit-button">
            Enregistrer
        </button>

      </form>
  )
}

export default PartnersForm